import { render, staticRenderFns } from "./CardHelp.vue?vue&type=template&id=30388123"
import script from "./CardHelp.vue?vue&type=script&lang=ts"
export * from "./CardHelp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports